import { useEffect, useState } from 'react'
import getFirebaseInstance from './firebase'
import loadFirebaseDependencies from './loadFirebaseDependencies'

function useAuth () {
  const [user, setUser] = useState(null)
  const [firebase, setFirebase] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let unsubscribe;
    let publicProfileUnsubscribe;
  
    // Lade Firebase-Abhängigkeiten und initialisiere die Instanz
    loadFirebaseDependencies.then((app) => {
      const firebaseInstance = getFirebaseInstance(app);
      setFirebase(firebaseInstance);
  
      unsubscribe = firebaseInstance.auth.onAuthStateChanged((userResult) => {
        if (userResult) {
          publicProfileUnsubscribe = firebaseInstance.getUser({
            userId: userResult.uid,
            handler: (r) => {
              if (firebaseInstance.auth.currentUser) {
                firebaseInstance.auth.currentUser
                  .getIdTokenResult(true)
                  .then((token) => {
                    setUser({
                      ...userResult,
                      isAdmin: token.claims.admin,
                      username: r.empty ? null : r.docs[0].data().username,
                      organization: r.empty ? null : r.docs[0].data().organization,
                      organizationId: r.empty ? null : r.docs[0].data().organizationId,
                    });
                  })
                  .catch((error) => {
                    console.error('Error fetching ID token:', error);
                  });
              } else {
                console.log('Current user is null, skipping token retrieval');
              }
            },
          });
        } else {
          // Wenn der Benutzer abgemeldet ist
          if (publicProfileUnsubscribe) {
            publicProfileUnsubscribe();
          }
          setUser(null);
        }
        setLoading(false);
      });
    });
  
    // Cleanup-Funktion: Entfernt alle Abos, wenn die Komponente unmontiert wird
    return () => {
      if (unsubscribe) {
        unsubscribe(); // Entferne den Auth-Listener
      }
      if (publicProfileUnsubscribe) {
        publicProfileUnsubscribe(); // Entferne den Profil-Listener, falls er gesetzt wurde
      }
    };
  }, []);
  

  // const reloadUser = async () => {
  //   if (firebase && firebase.auth.currentUser) {
  //     await firebase.auth.currentUser.reload();
  //     const userResult = firebase.auth.currentUser;

  //     const userProfile = await firebase.getUser({
  //       userId: userResult.uid,
  //     });

  //     const token = await userResult.getIdTokenResult(true);

  //     setUser({
  //       ...userResult,
  //       isAdmin: token.claims.admin,
  //       username: userProfile.empty ? null : userProfile.docs[0].data().username,
  //       organization: userProfile.empty ? null : userProfile.docs[0].data().organization,
  //       organizationId: userProfile.empty ? null : userProfile.docs[0].data().organizationId,
  //       mfaInfo: userResult.reloadUserInfo.mfaInfo
  //     });
  //   }
  // };

  return { user, firebase, loading }
}

export default useAuth
